import { createFileRoute } from "@tanstack/react-router";
import { CatalogPage } from "@/pages/CatalogPage";

export interface CatalogSearch {
  /** Catalog の表示モード切替 (PC のみ有効、mobile では URL は preserve するが UI は catalog) */
  view?: "list" | "catalog";
}

// biome-ignore lint/nursery/useExplicitType: 型が長く書き出してもメリットが薄い
export const Route = createFileRoute("/$boardSlug/")({
  component: CatalogPage,
  validateSearch: (search: Record<string, unknown>): CatalogSearch => {
    const view = search.view;
    return {
      view: view === "list" || view === "catalog" ? view : undefined,
    };
  },
});
